import React from "react";
import { Link } from "react-router-dom";
import LikeButton from "../common/heart/heart";

export type ArtworkCardData = {
  id: number;
  name: string;
  image: string;
  likes?: unknown[];
};

type ArtworkCardProps = {
  artwork: ArtworkCardData;
  imageBaseUrl: string;
};

const ArtworkCard = ({ artwork, imageBaseUrl }: ArtworkCardProps) => {
  const imageSrc = `${imageBaseUrl}/${artwork.image}`;

  return (
    <article className="art-card scrollAnim">
      <Link className="art-card__link focus-ring" to={`/oeuvre/${artwork.id}`}>
        <figure className="art-card__media image-frame">
          <img src={imageSrc} alt={artwork.name} />
        </figure>
        <div className="art-card__meta">
          <span className="mono-label">Oeuvre</span>
          <h2>{artwork.name}</h2>
        </div>
      </Link>
      <div className="art-card__like">
        <LikeButton likesCount={artwork.likes ? artwork.likes.length : 0} oeuvreId={artwork.id} />
      </div>
    </article>
  );
};

export default ArtworkCard;

